import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "card-group" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DeviceComponent = _resolveComponent("DeviceComponent")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.devices, (device) => {
      return (_openBlock(), _createBlock(_component_DeviceComponent, {
        key: device.id,
        device: device,
        deviceModified: _ctx.reorder()
      }, null, 8, ["device", "deviceModified"]))
    }), 128))
  ]))
}